import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const field = "w-full bg-transparent border-b border-[#2A1F14]/15 py-3 text-[#2A1F14] focus:border-gold outline-none transition-colors placeholder:text-[#2A1F14]/30";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (!token) toast.error("Link non valido o scaduto."); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("La password deve avere almeno 6 caratteri.");
    if (pwd !== pwd2) return toast.error("Le password non coincidono.");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset", { token, new_password: pwd });
      toast.success(data.message || "Password aggiornata.");
      nav("/accedi");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 constellation">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-12">
          <span className="font-display text-2xl tracking-[0.2em] text-[#2A1F14]">LUX</span>
          <span className="w-1 h-1 rounded-full bg-gold" />
          <span className="font-display text-2xl tracking-[0.2em] text-gold">AETERNA</span>
        </Link>
        <div className="glass rounded-2xl p-8">
          <h1 className="font-display text-2xl text-[#2A1F14] mb-2">Reimposta la password</h1>
          <p className="text-[#2A1F14]/60 text-sm mb-8">Inserisci la tua nuova password.</p>
          <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
            <input required type="password" placeholder="Nuova password" value={pwd} onChange={(e) => setPwd(e.target.value)} className={field} data-testid="reset-pwd" />
            <input required type="password" placeholder="Conferma password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className={field} data-testid="reset-pwd2" />
            <button disabled={loading || !token} data-testid="reset-submit" className="w-full py-4 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors disabled:opacity-50">
              {loading ? "Salvataggio..." : "Reimposta password"}
            </button>
          </form>
          <p className="text-center text-[#2A1F14]/40 text-xs mt-6"><Link to="/accedi" className="link-underline">Torna al login</Link></p>
        </div>
      </div>
    </div>
  );
}
